import InstanceApi from "@/services/apiClient.js";
import { formatSaveSimulatoLeadRequest } from "@/helpers/simulator";

const GET_LEAD_CATEGORY_AND_PRODUCT = "simulateur-avance/steps/getCategory";
const GET_FIRST_STEP = "simulateur-avance/steps/getFirstStep";
const GET_SECOND_STEP = "simulateur-avance/steps/getSecondStep";
const SAVE_WIZARD_URL = "mcp/checkout/saveWizardWidget";
const UPDATE_WIZZARD_URL = "simulateur-avance/steps/update/";
const GET_FIRST_STEP_RESULT = "simulateur-avance/steps/getFirstStepResult";
/**
 * Set current step
 * @param {Object} state 
 * @param {String} step 
 */
const setCurrentStep = (state, step) => {
  state.commit("SET_CURRENT_STEP", step);
}

/**
 * Validate step
 * @param {Object} state 
 * @param {String} step 
 */
const setValideStep = (state, step) => {
  state.commit("SET_VALIDE_STEP", step)
}

/**
 * Fetch Lead form step questions
 * @param {Object} state 
 * @returns 
 */
const setDwellingTunnelForm = async (state) => {
    try {
      const response = await InstanceApi.get(GET_FIRST_STEP);
      state.commit("SET_DWELLING_FORM_QUESTIONS", response.data);
    }catch (err) {
      console.error("setDwellingTunnelForm failure", err);
      return { error: err };
    }
}

const setAidsTunnelForm = async (state) => {
  try {
    const response = await InstanceApi.get(GET_SECOND_STEP);
    state.commit("SET_AIDS_FORM_QUESTIONS", response.data);
  }catch (err) {
    console.error("setDwellingTunnelForm failure", err);
    return { error: err };
  }
}

/**
 * fetch lead product and category
 * @param {Object} state 
 * @returns 
 */
const fetchLeadConfig = async (state) => {
  try {
    const response = await InstanceApi.get(GET_LEAD_CATEGORY_AND_PRODUCT);
    state.commit("SET_LEAD_PRODUCT", response.data.product);
    state.commit("SET_LEAD_CATEGORY", response.data.category);
  }catch (err) {
    console.error("fetchLeadCategoryAndProduct failure", err);
    return { error: err };
  }
}

/**
 * Set questions key and answers
 * @param {Object} state 
 * @param {Object} answerDatas 
 * @param {String} formName
 */
const setAnswerDatas = (state, answerDatas) => {
  state.commit("SET_ANSWER_DATAS", answerDatas);
}

/**
 * Save callBack resume after first Lead step 
 * @param {Object} state 
 * @param {Object} datas 
 */
const saveDwellingStepResume = (state, datas) => {
  state.commit("SAVE_DWELLING_STEP_RESUME", datas)
}

/**
 * Clear answers results
 * @param {Object} state 
 */
const clearDwellingForm = (state) => {
    state.commit("CLEAR_DWELLING_FORM");
}

/**
 * Set information to determine the simulator path
 * @param {Object} state 
 * @param {Object} params infoKey - infoValue
 */
const setSimulatorPathInfos = (state, params) => {
  state.commit("SET_SIMULATOR_PATH_INFOS", params)
}

/**
 * Create / Update Lead
 * @param {Object} state 
 * @returns 
 */
const doSaveLead = async (state, params ) => {
    try {
        const dwellingStepAnswers   = state.getters.getDwellingStepAnswers;
        const requiredInfo          = state.getters.getLeadFormAnswers;
        const savingOptionAnswers   = state.getters.getSavingOptionsAnswers;
        const aidsStepAnswers       = state.getters.getAidsStepAnswers;
        const mcpDpe                = state.getters.getMcpDpe;
  
        let bodyFormData = formatSaveSimulatoLeadRequest(
          dwellingStepAnswers,
          requiredInfo,
          savingOptionAnswers,
          aidsStepAnswers,
          mcpDpe
        ) 

        let saveLeadResponse;
        
        if(!params.saveLead) {
          //Don't save lead just get mcp_dpe and other datas
          saveLeadResponse = await InstanceApi.post(GET_FIRST_STEP_RESULT, bodyFormData);
        }
        else if(!state.state.lead_config.lead_created && params.saveLead) {
          /* call save wizard data */
          saveLeadResponse = await InstanceApi.post(SAVE_WIZARD_URL, bodyFormData);
          setLeadCreated(state);
        } else {
          /* call update wizard data */
          saveLeadResponse = await InstanceApi.post(UPDATE_WIZZARD_URL + params.step, bodyFormData);
        }
    
        // throw error
        if (saveLeadResponse.data.success == false && saveLeadResponse.data.message) throw saveLeadResponse.data.message || "failure";

        setSimulatorPathInfos(state, {infoKey: 'is_low_dpe_eligible_to_aids', infoValue: saveLeadResponse.data?.simulator_advanced?.is_low_dpe_eligible_to_aids})
        setSimulatorPathInfos(state, {infoKey: 'is_home_owner', infoValue: dwellingStepAnswers.mcp_home_ownership !== "tenant"})
        setSimulatorPathInfos(state, {infoKey: 'overall_renovation_contact', infoValue: dwellingStepAnswers?.mcp_overall_renovation == "Oui"})


        if(params.step === "?step_number=1") {
          saveDwellingStepResume(state, saveLeadResponse.data.simulator_advanced);

          return { success: true, data: saveLeadResponse.data };
        } 
        

        // Success
        return { success: true, data: saveLeadResponse.data.simulator_advanced };
        
    } catch (err) {
        console.error("saveLead failure", err);
        return { error: err };
    }

    return { success: true };
};


/**
 * Set first create lead
 * @param {Object} state 
 */
const setLeadCreated = (state) => {
  state.commit("SET_LEAD_CREATED")
}

/**
 * Save previous question to go back
 * @param {Object} state 
 * @param {Object} questionDatas 
 */
const setPreviousQuestion = (state, questionDatas) => {
  state.commit("SET_PREVIOUS_QUESTION", questionDatas)
}

/**
 * Remove validate steps after current step (on return)
 * @param {Objec} state 
 * @param {String} currentStep 
 */
const spliceValidateSteps = (state, currentStep) => {
  state.commit("SPLICE_VALIDATE_STEPS", currentStep)
}

const setGtmEventsDatas = (state, datas) => {
  state.commit("SET_GTM_EVENTS_DATAS", datas)
}

/**
 * Set energy dpe label
 * @param {Object} state 
 * @param {String} mcpDpe 
 */
const setMcpDpe = (state, mcpDpe) => {
  state.commit("SET_MCP_DPE", mcpDpe)
}

/**
 * Remove question and his answer
 * @param {Object} state 
 * @param {Object} params - params.questionKey / params.formName
 */
const removeQuestionAndAnswer = (state, params) => {
  state.commit("REMOVE_QUESTION_ANSWER", params)
}
 
export default {
    setDwellingTunnelForm,
    setAidsTunnelForm,
    setAnswerDatas,
    clearDwellingForm,
    doSaveLead,
    saveDwellingStepResume,
    setLeadCreated,
    fetchLeadConfig,
    setCurrentStep,
    setValideStep,
    setPreviousQuestion,
    spliceValidateSteps,
    setMcpDpe,
    removeQuestionAndAnswer,
    setSimulatorPathInfos,
    setGtmEventsDatas
};
